export const TrimEditableEventCollection = [
  'r->t:dis-select',
  'r->t:change-allow-margin',
  'r->t:image-resize-in/out/eq',
  'r->t:image-guide-on/off',
  'r->t:shift-move',
  'r->t:resize',
  'r->t:rotate',
  'r->t:delete',
  'r->t:move-mode',
  'r->t:insert-text:start',
  'r->t:reload-text',
  'r->t:insert-text:end',
  'r->t:delete-text',
  'r->t:finish-text-edit',
  'r->t:center-line',
  'r->t:ruler',
  'r->t:add-editable-image',
  'r->t:change-operation-cursor',
  'r->t:reset',
  'r->t:change-image/frame',
  'r->t:editable-image:drag:check',
  'r->t:editable-image:drop',
  'r->t:editable-image:drop:direct',
  'r->t:editable-image:drop:temp',
  'r->t:rotate-additional',
  'r->t:transform-additional',
  'r->t:transparent-additional',
  'r->t:change-middle-frame',
  'r->t:check:open-trim-menu',
  'r->t:trim:start',
  'r->t:show-trim-line',
  'r->t:show-guide-line',
  'r->t:show-select-guide',
  'r->t:create-guide:start',
  'r->t:delete-guide',
  'r->t:close-trim-menu',
  'r->t:shortcut:save-trim:focus-out',
];
